import styled from "styled-components";
import {
  Dialog,
  Button,
  SearchInput,
  ListWrapper,
  ListItem,
  PrimaryButton,
  Heading,
  HEADING_LEVELS,
  HEADING_TYPES,
  CardWrapper,
} from "@cdkglobal/radial";
import type { HeadingProps } from "@cdkglobal/radial";
import type React from "react";

export const StyledGroupCodesDialog = styled(Dialog)`
  min-width: 60vw;
  z-index: 2000;
`;

export const StyledGroupCodesFieldsRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 0.5rem;
  margin: 0.5rem 0;

  & > * {
    flex: 1;
  }
`;

export const StyledGroupCodesTable = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.5);
  border-radius: 0.5rem;
  padding: 0.2rem;
`;

export const StyledHeaderTitle = styled(
  Heading as React.ComponentType<HeadingProps>,
).attrs({
  level: HEADING_LEVELS.LEVEL_4,
  type: HEADING_TYPES.SUBTITLE_1,
})`
  margin: 0rem 0.5rem;
`;

export const StyledDashboardSetupTitle = styled(
  Heading as React.ComponentType<HeadingProps>,
).attrs({
  level: HEADING_LEVELS.LEVEL_4,
  type: HEADING_TYPES.SUBTITLE_1,
})`
  margin: 1px;
`;

export const StyledHeaderSubTitle = styled(
  Heading as React.ComponentType<HeadingProps>,
).attrs({
  level: HEADING_LEVELS.LEVEL_4,
  type: HEADING_TYPES.SUBTITLE_1,
})`
  margin: 1px;
`;

export const StyledFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

// ShippingInfo CoRelation rows Styles
export const ShippingInfoRowsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
`;

export const StyledShippingInfoSearchInput = styled(SearchInput)`
  box-shadow: none;
  z-index: 2000;
`;

export const ShippingInfoCardRowWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(19rem, 1fr));
`;

export const TextButtonWrapper = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
  display: flex;
  gap: 0.5rem;
`;

export const AddressCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 20rem;
  padding: 0.75rem;
  gap: 0.5rem;
  border: 1px solid rgb(206, 204, 204);
  border-radius: 0.5rem;
  box-sizing: border-box;
`;

export const AddressHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const AddressName = styled.div``;

export const DefaultLabel = styled.div`
  background-color: #f0f0f0;
  color: black;
  border: 2px solid gray;
  border-radius: 0.25rem;
  text-align: center;
  min-width: 3.5rem;
  line-height: 1.25rem;
  cursor: pointer;
  margin-top: -0.5rem;
`;

export const AddressLines = styled.div``;

export const AddressActions = styled.div`
  display: flex;
`;

export const StyledAddressActionItem = styled(Button)``;

// ShippingInfo Dialog Styles
export const StyledShippingInfoDialog = styled(Dialog)`
  padding: 1rem;
  min-width: 70vw;
  z-index: 2000;
`;

export const StyledShippingInfoImportDialog = styled(Dialog)`
  padding: 1rem;
  width: 70vw;
  height: 80vh;
  z-index: 2000;
`;

export const ShippingInfoInputsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(14rem, 0fr));
  gap: 0.75rem;
  margin-bottom: 1rem;
  z-index: 2000;
`;

export const StyledConfirmationDialog = styled(Dialog)`
  padding: 0.1rem;
  width: 20vw;
  height: 25vh;
  z-index: 2010;
`;

export const Wrapper = styled(ListWrapper)`
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
  max-width: 75%;
`;

export const Item = styled(ListItem)`
  display: flex;
  background-color: #f4f4f4;
  border-radius: 0.75rem;
`;

export const DiscountCopySettingsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
`;

export const CopyRadioGroup = styled.div`
  fieldset > div {
    display: flex;
    flex-direction: row;
  }
`;

export const CopyRadioOption = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
`;

export const DiscountCopySettingsCopyButton = styled(PrimaryButton)`
  flex-shrink: 0;
  margin-left: auto;
`;

export const DefaultCardWrapper = styled(CardWrapper)`
  margin-bottom: 1rem;
  padding: 1rem;
`;

export const DefaultAddressHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 0.5rem;
`;
